import React, { useEffect, useState } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import Spinners from "components/Common/Spinner"
import closeIcon from "../../../assets/images/icons/close.svg"
import toast from "react-hot-toast"
import { useSelector } from "react-redux"
import PhoneVerificationIcon from "../../../assets/images/icons/phone-verification.svg"
import BankDetailIcon from "../../../assets/images/icons/bank-details.svg"
import AdditionalDetailsIcon from "../../../assets/images/icons/additional-details.svg"
import IDVerificationIcon from "../../../assets/images/icons/id-verification.svg"
import SignaturePhoto from "../../../assets/images/icons/signature-and-photo.svg"
import AuthorisedSignatoryIcon from "../../../assets/images/icons/authorised-signatory-kyc.svg"
import { useSaveUpdateStepsMutation } from "store/api/profile/profile.api"
import { useNavigate } from "react-router-dom"

const individualSteps = [
  {
    label: "ID Details",
    key: "ID_VERIFICATION",
    icon: IDVerificationIcon,
  },
  {
    label: "Bank Details",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  {
    label: "Additional Details",
    key: "ADDITIONAL_DETAILS",
    icon: AdditionalDetailsIcon,
  },
  // {
  //   label: "Signature",
  //   key: "SIGNATURE",
  //   icon: SignaturePhoto,
  // },
  {
    label: "Photo",
    key: "PHOTO",
    icon: SignaturePhoto,
  },
]

const nonIndividualSteps = [
  {
    label: "Company Details",
    key: "PAN_GST",
    icon: IDVerificationIcon,
  },
  {
    label: "Bank Details",
    key: "BANK_VERIFICATION",
    icon: BankDetailIcon,
  },
  {
    label: "Authorised Person",
    key: "AUTHORISED_SIGNATORY",
    icon: AuthorisedSignatoryIcon,
  },
]
function UpdateProfileSteps({ id, open, setOpen }) {
  const { user, userType } = useSelector((state) => state.user)
  const [steps, setSteps] = useState([])
  const [originalSteps, setOriginalSteps] = useState([])
  const [selectedSteps, setSelectedSteps] = useState([])
  const [onSubmit, { isLoading }] = useSaveUpdateStepsMutation()
  const navigate = useNavigate()

  useEffect(() => {
    const steps =
      user?.entity_type === "COMPANY" ? nonIndividualSteps : individualSteps
    setSteps(steps)
    setOriginalSteps(steps)
  }, [user])

  const handleSubmit = async () => {
    try {
      const params = originalSteps.filter((item) =>
        selectedSteps.includes(item.key)
      )
      const { success, message } = await onSubmit(params).unwrap()
      if (success) {
        setOpen(false)
        navigate("/profile/update")
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }
  return (
    <>
      <Modal
        isOpen={open}
        toggle={() => {
          setOpen((prev) => !prev)
        }}
        returnFocusAfterClose={true}
        centered
        className="custom-size"
      >
        <ModalHeader
          toggle={() => {
            setOpen((prev) => !prev)
          }}
        >
          {"Select Steps to Update."}
          <p style={{ fontSize: "14px", fontWeight: "400", marginBottom: 0 }}>
            {"Please select steps and proceed with update profile"}
          </p>
        </ModalHeader>
        <ModalBody>
          <div className="">
            <div className="d-flex flex-column raise-query-modal-wrapper">
              {steps.length > 0 && (
                <>
                  {steps.map((item, index) => (
                    <div
                      className="d-flex align-items-center justify-content-start gap-3"
                      key={`selectedSteps_${index}`}
                      style={{
                        cursor: "pointer",
                        padding: "15px 20px",
                        boxShadow: `0px 0px 1px 1px ${
                          selectedSteps.includes(item.key)
                            ? "#f0a634"
                            : "#afafaf"
                        }`,
                        marginBottom: "20px",
                        borderRadius: "7px",
                      }}
                      onClick={() => {
                        const isSelected = selectedSteps.includes(item.key)
                        const newPreferences = isSelected
                          ? selectedSteps.filter((v) => v !== item.key)
                          : [...selectedSteps, item.key]
                        setSelectedSteps(newPreferences)
                      }}
                    >
                      <div className="form-check form-check-primary">
                        <input
                          type="checkbox"
                          id={item.key}
                          value={item.key}
                          className="form-check-input"
                          readOnly
                          checked={selectedSteps.includes(item.key)}
                          style={{ pointerEvents: "none" }}
                        />
                      </div>
                      <div>
                        <span
                          style={{
                            fontWeight: "500",
                            marginRight: "5px",
                            fontSize: "15px",
                          }}
                        >
                          {item.label}
                        </span>
                        <div
                          style={{ color: "#a5a5a5", whiteSpace: "pre-wrap" }}
                        >
                          {item.message}
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          {selectedSteps.length > 0 && (
            <div className="mt-3 pt-3 mb-0 button-wrapper buttons position-relative z-2">
              <button
                onClick={() => onClose()}
                type="button"
                className="cancel"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="approve btn btn-secondary"
                onClick={handleSubmit}
              >
                {isLoading ? <Spinners /> : "Next Step"}
              </button>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  )
}

export default UpdateProfileSteps
